import React from "react";
import { useTranslation } from "react-i18next";

import "./PhotoPage.css";
import { IMAGES } from "../utils/GetImages";
import { getTranslation } from "../utils/translation";
import { getPDFUrls } from "../utils/config";

export default function PhotoPage() {
  const { i18n } = useTranslation();
  const pdfUrls = getPDFUrls();

  const PhotoPagePicture1 = IMAGES["PhotoPage-Picture1.png"];
  const PhotoPagePicture2 = IMAGES["PhotoPage-Picture2.png"];
  const PhotoPagePicture3 = IMAGES["PhotoPage-Picture3.png"];

  return (
    <div className="photo-page-background">
      <div className="photo-page-container">
        <h2 className="photo-page-title">
          {getTranslation(i18n, "photoPage.pageTitle")}
        </h2>
        <section id="photos">
          <div className="photo-page-photo">
            <img src={PhotoPagePicture1} />
            <p>{getTranslation(i18n, "photoPage.description1")}</p>
          </div>
          <div className="photo-page-photo">
            <img src={PhotoPagePicture2} />
            <p>{getTranslation(i18n, "photoPage.description2")}</p>
          </div>
          <div className="photo-page-photo">
            <img src={PhotoPagePicture3} />
            <p>{getTranslation(i18n, "photoPage.description3")}</p>
          </div>
        </section>

        {/* PDF View More Section */}
        {pdfUrls.photoGallery && (
          <div className="pdf-view-more-section">
            <div className="pdf-view-more-content">
              <h3 className="pdf-view-more-title">
                {getTranslation(i18n, "photoPage.viewMore") || "View More"}
              </h3>
              <p className="pdf-view-more-description">
                {getTranslation(i18n, "photoPage.viewMoreDescription") ||
                  "Download our photo gallery PDF for more amazing photos"}
              </p>
              <a
                href={pdfUrls.photoGallery}
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-view-more-button"
              >
                📸{" "}
                {getTranslation(i18n, "photoPage.downloadGallery") ||
                  "Download Gallery"}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
